import { APITransport } from '@client/transports/api';

export const IntegrationsService = {
  disconnectOutreach(body = {}) {
    return APITransport.post({
      path: '/rest/domain/disconnectoutreach',
      body
    });
  }
};
